<template>
  <ValidationObserver
    v-bind="$attrs"
    ref="validationObserver"
    v-slot="{ valid }"
  >
    <slot :handleSubmit="handleSubmit" :resetForm="resetForm" :valid="valid" />
  </ValidationObserver>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import ValidationObserver from "@/components/organisms/validation/ValidationObserver.vue";
import { scrollTo } from "@/utils/scrollUtil";

@Component
export default class CustomValidationObserver extends Vue {
  async handleSubmit(action: Function) {
    const validationObserver = this.$refs
      .validationObserver as typeof ValidationObserver;
    const { valid } = await validationObserver.validate();
    if (!valid) {
      const element = document.querySelector(".is-invalid") as HTMLElement;
      if (!element) {
        return;
      } else if (element.nodeName === "SELECT") {
        this.focusSelectElement(element);
      } else {
        element.focus();
      }
      return;
    }
    await action();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resetForm(values: any) {
    const validationObserver = this.$refs
      .validationObserver as typeof ValidationObserver;
    validationObserver.reset(values);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setErrors(values: any) {
    const validationObserver = this.$refs
      .validationObserver as typeof ValidationObserver;
    validationObserver.setErrors(values);
  }

  // 通常のfocusだとプルダウンの選択肢が全面表示されるため、本メソッドで他input要素と同様のfocusの挙動を行う
  focusSelectElement = (element: HTMLElement) => {
    element.classList.add("focus");
    scrollTo(window, element, { offset: -90, duration: 0 });

    // デフォルトの「他の要素をクリックした際にフォーカスが外れる挙動」を再現するためにイベントを追加
    document.addEventListener("click", () => this.removeFocusClass(element), {
      once: true
    });
  };

  removeFocusClass = (element: HTMLElement) => {
    // 保存ボタン押下時のclickイベントで意図せずリスナーが実行されるため、イベントリスナー内で再度リスナーを登録
    // 保存ボタン押下の次のclickイベント時に、focusクラスをremoveするリスナーを実行させる
    document.addEventListener(
      "click",
      () => {
        element.classList.remove("focus");
      },
      {
        once: true,
        capture: true
      }
    );
  };
}
</script>

<style lang="scss">
.focus {
  border-color: #d23e36;
  box-shadow: 0 0 0 3px #f4cccc;
}
</style>
